var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.33337H4.66659C2.82564 1.33337 1.33325 2.82576 1.33325 4.66671V11.3334C1.33325 13.1743 2.82564 14.6667 4.66659 14.6667H11.3333C13.1742 14.6667 14.6666 13.1743 14.6666 11.3334V4.66671C14.6666 2.82576 13.1742 1.33337 11.3333 1.33337Z",
    stroke: "#E5194D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 7.57996C10.7488 8.13479 10.6541 8.70143 10.3957 9.1993C10.1374 9.69717 9.72865 10.1009 9.22764 10.3531C8.72662 10.6052 8.15885 10.693 7.60508 10.6039C7.0513 10.5148 6.53973 10.2533 6.14311 9.85673C5.7465 9.46012 5.48504 8.94854 5.39593 8.39477C5.30682 7.84099 5.3946 7.27322 5.64677 6.77221C5.89894 6.27119 6.30268 5.86245 6.80054 5.60412C7.29841 5.34578 7.86506 5.25102 8.41989 5.33329C8.98584 5.41721 9.50979 5.68093 9.91435 6.08549C10.3189 6.49006 10.5826 7.01401 10.6666 7.57996Z",
    stroke: "#E5194D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 4.33337H11.6734",
    stroke: "#E5194D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bbfd90191d1253dff19c8482bdd88a03.svg";
export { ForwardRef as ReactComponent };